/**
 * Load full catalog from paginated GET endpoints (limit/skip + total).
 */
export async function fetchAllPaged(httpClient, path, itemsKey, pageSize = 500) {
  const out = [];
  let skip = 0;
  let total = null;
  const maxIterations = 200;

  for (let i = 0; i < maxIterations; i += 1) {
    const { data } = await httpClient.get(path, {
      params: { limit: pageSize, skip },
    });
    const batch = data[itemsKey] || [];
    if (total === null && typeof data.total === "number") total = data.total;

    out.push(...batch);

    if (batch.length === 0) break;
    if (typeof total === "number" && out.length >= total) break;
    skip += batch.length;

    if (batch.length < pageSize) break;
  }

  return out;
}
